import {
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { tabVisible } from '@platform/plugin-platform-react';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';

/**
 * L'onglet couvrait jusqu'ici DEUX endroits : la colonne vertebrale des
 * charges de travail (`entityRoutes.tsx`, services et agents) et la page des
 * composants de type `website` (`EntityPage.tsx`). Le filtre reprend leur
 * union — le kind `component` — plutot que d'elargir a toutes les entites,
 * ce qu'une extension sans filtre aurait fait en silence.
 */
const isComponent = (entity: Entity): boolean =>
  entity.kind?.toLowerCase() === 'component';

/**
 * L'onglet « Sécurité » des charges de travail déployées.
 *
 * Il était déclaré dans `entityRoutes.tsx` et enveloppé dans un `SecurityGate`
 * qui masquait l'onglet sans la permission. Ce garde n'existe plus : la
 * vérification vit désormais dans `SecurityTab` lui-même (`usePermission`),
 * conformément à la dissolution d'`entityShared.tsx` prévue par la spec.
 *
 * Perte connue, la même que pour les entrées de menu des plugins natifs :
 * l'onglet reste visible pour qui n'a pas `platform.security.read`, et c'est
 * son contenu qui refuse. Un onglet masqué demanderait que le filtre puisse
 * consulter les permissions, ce que `EntityContentBlueprint` ne permet pas —
 * son `filter` ne reçoit que l'entité.
 */
const securityContent = EntityContentBlueprint.make({
  name: 'security',
  params: {
    path: '/security',
    title: 'Sécurité',
    filter: tabVisible('security', isComponent),
    loader: () => import('./SecurityTab').then(m => <m.SecurityTab />),
  },
});

export default createFrontendPlugin({
  pluginId: 'security-insights',
  extensions: [securityContent],
});
